class AnnouncementCarousel {
  constructor(container) {
    this.container = container;
    this.items = Array.from(container.querySelectorAll(".js-announcement-item"));
    this.current = 0;
    this.interval = null;
    this.delay = 3000;
    this.isVisible = document.visibilityState === "visible";
    this.changeTimeout = null;

    if (this.items.length <= 1) return;

    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      item.classList.toggle("active", index === 0);
      item.classList.remove("deactivate");
    });

    this.handleMouseEnter = () => this.pause();
    this.handleMouseLeave = () => this.start();

    this.handleVisibilityChange = () => {
      this.isVisible = document.visibilityState === "visible";

      if (this.isVisible) {
        this.restoreCurrentState();
        this.start();
      } else {
        this.pause();
      }
    };

    this.container.addEventListener("mouseenter", this.handleMouseEnter);
    this.container.addEventListener("mouseleave", this.handleMouseLeave);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    this.start();
  }

  start() {
    this.clearIntervalOnly();

    if (!this.isVisible || this.items.length <= 1 || this.changeTimeout) return;

    this.interval = setInterval(() => {
      this.next();
    }, this.delay);
  }

  pause() {
    this.clearIntervalOnly();
  }

  clearIntervalOnly() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  clearAllTimers() {
    this.clearIntervalOnly();

    if (this.changeTimeout) {
      clearTimeout(this.changeTimeout);
      this.changeTimeout = null;
    }
  }

  restoreCurrentState() {
    this.items.forEach((item, index) => {
      item.classList.remove("deactivate");
      item.classList.toggle("active", index === this.current);
    });

    if (this.changeTimeout) {
      clearTimeout(this.changeTimeout);
      this.changeTimeout = null;
    }
  }

  next() {
    if (this.items.length <= 1 || this.changeTimeout) return;

    const currentItem = this.items[this.current];
    currentItem.classList.add("deactivate");

    this.clearIntervalOnly();

    this.changeTimeout = setTimeout(() => {
      currentItem.classList.remove("active", "deactivate");

      this.current = (this.current + 1) % this.items.length;

      const nextItem = this.items[this.current];
      nextItem.classList.add("active");

      this.changeTimeout = null;
      this.start();
    }, 1000);
  }

  setActiveByBlockId(blockId) {
    const index = this.items.findIndex((item) => item.dataset.blockId === blockId);
    if (index === -1) return;

    this.clearAllTimers();

    this.items.forEach((item) => {
      item.classList.remove("active", "deactivate");
    });

    this.current = index;
    this.items[this.current].classList.add("active");
  }

  destroy() {
    this.clearAllTimers();

    this.container.removeEventListener("mouseenter", this.handleMouseEnter);
    this.container.removeEventListener("mouseleave", this.handleMouseLeave);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }
}

const announcementCarousels = new Map();

function initAnnouncementCarousel(container) {
  if (!container) return;

  const existingInstance = announcementCarousels.get(container);
  if (existingInstance) {
    existingInstance.destroy();
  }

  const instance = new AnnouncementCarousel(container);

  if (instance.items && instance.items.length > 1) {
    announcementCarousels.set(container, instance);
  }
}

function destroyAnnouncementCarousel(container) {
  const instance = announcementCarousels.get(container);
  if (!instance) return;

  instance.destroy();
  announcementCarousels.delete(container);
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-announcement-carousel").forEach((container) => {
    initAnnouncementCarousel(container);
  });
});

document.addEventListener("shopify:section:load", (event) => {
  const container = event.target.querySelector(".js-announcement-carousel");
  if (container) {
    initAnnouncementCarousel(container);
  }
});

document.addEventListener("shopify:section:unload", (event) => {
  const container = event.target.querySelector(".js-announcement-carousel");
  if (container) {
    destroyAnnouncementCarousel(container);
  }
});

document.addEventListener("shopify:block:select", (event) => {
  const container = event.target.closest(".shopify-section")?.querySelector(".js-announcement-carousel");
  if (!container) return;

  const instance = announcementCarousels.get(container);
  if (!instance) return;

  instance.setActiveByBlockId(event.detail.blockId);
});

document.addEventListener("shopify:block:deselect", (event) => {
  if (!Shopify.designMode) return;

  const container = event.target.closest(".shopify-section")?.querySelector(".js-announcement-carousel");
  if (!container) return;

  const instance = announcementCarousels.get(container);
  if (!instance) return;

  instance.restoreCurrentState();
  instance.start();
});